"use client";

import type { CheckStatus, RuleSeverity } from "@/types/aicheck";

const statusStyles: Record<string, string> = {
  pass: "bg-green-50 text-green-700 border border-green-200",
  warning: "bg-yellow-50 text-yellow-700 border border-yellow-200",
  fail: "bg-red-50 text-red-700 border border-red-200",
  error: "bg-red-50 text-red-700 border border-red-200",
  skipped: "bg-zinc-50 text-zinc-600 border border-zinc-200",
  info: "bg-blue-50 text-blue-700 border border-blue-200",
};

const statusIcons: Record<string, string> = {
  pass: "\u2713",
  warning: "\u26A0",
  fail: "\u2717",
  error: "\u2717",
  skipped: "\u2014",
  info: "i",
};

export function StatusBadge({
  status,
}: {
  status: CheckStatus | RuleSeverity | "info";
}) {
  return (
    <span
      className={`inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-xs font-medium ${statusStyles[status] ?? statusStyles.skipped}`}
    >
      <span>{statusIcons[status] ?? ""}</span>
      {status}
    </span>
  );
}
